import PropTypes from "prop-types";
import Button from "./Button";

export default function PricingCard({
  variant = "basic",
  price = "$29",
  description = "Best option for personal use & for your next project.",
  title = "Starter",
  supportDuration = "1 months",
  updatesDuration = "1 months",
  teamSize = "1 developer",
}) {
  const base =
    "flex flex-col p-6 mx-auto max-w-xs text-center rounded-lg shadow";

  const variants = {
    basic: "bg-white hover:shadow-lg",
    bordered: "bg-white border border-gray-200 hover:shadow-lg",
    colored: "bg-indigo-600 text-white hover:bg-indigo-700",
  };

  // Buton varyantlarının kart varyanlarına göre default ataması
  const buttonVariants = {
    basic: "buy1",
    bordered: "buy1",
    colored: "buy2",
  };

  return (
    <div className={`${base} ${variants[variant]} w-full`}>
      <h3 className="mb-4 text-2xl font-semibold">{title}</h3>
      <p
        className={`font-light ${
          variant === "colored" ? "text-white" : "text-gray-500"
        } sm:text-lg`}
      >
        {description}
      </p>
      <div className="flex justify-center items-baseline my-8">
        <span className="mr-2 text-5xl font-extrabold">{price}</span>
        <span
          className={`font-light ${
            variant === "colored" ? "text-white" : "text-gray-500"
          } sm:text-sm`}
        >
          /month
        </span>
      </div>
      <ul role="list" className="mb-8 space-y-4 text-left">
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
          <span>Individual configuration</span>
        </li>
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
          <span>No setup, or hidden fees</span>
        </li>
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
          <span>
            Team size: <span className="font-semibold">{teamSize}</span>
          </span>
        </li>
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
          <span>
            Premium support:{" "}
            <span className="font-semibold">{supportDuration}</span>
          </span>
        </li>
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
          <span>
            Free updates:{" "}
            <span className="font-semibold">{updatesDuration}</span>
          </span>
        </li>
      </ul>
      <div className="w-full mx-auto">
        <Button variant={buttonVariants[variant]}>Get Started</Button>
      </div>
    </div>
  );
}

PricingCard.propTypes = {
  variant: PropTypes.oneOf(["basic", "bordered", "colored"]),
  price: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  supportDuration: PropTypes.string,
  updatesDuration: PropTypes.string,
  teamSize: PropTypes.string,
};
